import React from 'react';
import ChanceContainer from '../../containers/chancemng/ChanceContainer';

const ChanceDetailPage = () => {
  return <ChanceContainer />
};

export default ChanceDetailPage;
